module.exports = __webpack_public_path__ + "images/common/linkedin.f257359e.svg";